import { render, staticRenderFns } from "./OverviewChatMessages.vue?vue&type=template&id=3f075b6e&scoped=true&"
import script from "./OverviewChatMessages.vue?vue&type=script&lang=js&"
export * from "./OverviewChatMessages.vue?vue&type=script&lang=js&"
import style0 from "./OverviewChatMessages.vue?vue&type=style&index=0&id=3f075b6e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f075b6e",
  null
  
)

export default component.exports